import { useState } from "react";

const apiBaseUrl = "https://api.avataranimals.com";

const endpointItems = [
	{
		id: "list-all-animals",
		title: "List all animals",
		endpointPath: "/api/animals",
		description: "Returns JSON with every animal slug and image URL.",
	},
	{
		id: "random-list",
		title: "Random list",
		endpointPath: "/api/animals/get?count=10",
		description: "Returns a random set of entries for galleries or seed data.",
	},
	{
		id: "direct-image-by-slug",
		title: "Direct image by slug",
		endpointPath: "/api/animals/:slug.webp",
		description: "Redirects to the CDN image for a specific animal.",
	},
	{
		id: "v1-random-image",
		title: "v1 random image",
		endpointPath: "/api/v1/animals/random?image=webp&background=transparent",
		description: "Add key= to keep randomization deterministic.",
	},
];

/**
 * Show the API endpoints with reference-styled cards and copy actions.
 */
export function EndpointsBlock() {
	const [copiedItemId, setCopiedItemId] = useState<string | null>(null);

	const copyValue = async (value: string, itemId: string) => {
		try {
			await navigator.clipboard.writeText(value);
			setCopiedItemId(itemId);
		} catch (error) {
			console.error("Clipboard write failed", error);
			return;
		}

		window.setTimeout(() => {
			setCopiedItemId((currentCopiedItemId) =>
				currentCopiedItemId === itemId ? null : currentCopiedItemId,
			);
		}, 1600);
	};

	return (
		<section id="api" className="api-sec">
			<div className="api-head">
				<div>
					<div className="kicker">◉ API</div>
					<h2>
						Available <em>endpoints</em>
					</h2>
				</div>
			</div>

			<div className="api-actions">
				<a className="btn primary" href="/animals">
					Browse all animals <span className="arrow">→</span>
				</a>
				<button
					type="button"
					className={`btn api-copy-btn ${copiedItemId === "base-url" ? "copied" : ""}`}
					onClick={() => copyValue(apiBaseUrl, "base-url")}
				>
					{copiedItemId === "base-url" ? (
						"Copied ✓"
					) : (
						<>
							Copy base URL <span className="arrow">⧉</span>
						</>
					)}
				</button>
			</div>

			<div className="api-grid">
				{endpointItems.map((endpointItem) => (
					<article className="api-card" key={endpointItem.id}>
						<div className="api-row1">
							<span className="api-method">GET</span>
							<span className="api-path">{endpointItem.endpointPath}</span>
						</div>
						<h4>{endpointItem.title}</h4>
						<p>{endpointItem.description}</p>
						<button
							type="button"
							className={`api-copy ${
								copiedItemId === endpointItem.id ? "copied" : ""
							}`}
							onClick={() =>
								copyValue(
									`${apiBaseUrl}${endpointItem.endpointPath}`,
									endpointItem.id,
								)
							}
						>
							{copiedItemId === endpointItem.id
								? "Copied ✓"
								: "Copy full URL ⧉"}
						</button>
					</article>
				))}
			</div>
		</section>
	);
}
